// extracted by mini-css-extract-plugin
module.exports = {"searchIconWrapper":"_4f0b69dd"};